(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CustomerCustom', CustomerCustom);

    CustomerCustom.$inject = ['$resource', 'ENV'];

    function CustomerCustom($resource, ENV) {


        var getCustomerByPhoneNumber = function (phoneNumber) {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-customer-by-phone-number?phoneNumber=' + phoneNumber;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var searchCustomerBySearch = function (query) {

            var resourceUrl = ENV.API_BASE_URL + 'api/search-current-company-customers?query=' + query;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getCustomerStatistics = function (customerId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-company-customer-statistics?customerId=' + customerId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var saveCompanyCustomer = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/service-customer-schedule-list';
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST'}
                }
            );
        };

        var getCustomerUserInfoByCustomerId = function (customerId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-customer-user-info-by-customer-id?customerId=' + customerId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getCustomerStatisticsV2 = function (customerId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-company-customer-statistics-v2?customerId=' + customerId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        return {
            getCustomerByPhoneNumber: getCustomerByPhoneNumber,
            searchCustomerBySearch: searchCustomerBySearch,
            saveCompanyCustomer: saveCompanyCustomer,
            getCustomerStatistics: getCustomerStatistics,
            getCustomerUserInfoByCustomerId: getCustomerUserInfoByCustomerId,
            getCustomerStatisticsV2: getCustomerStatisticsV2


        };
    }
})();
